import { render } from "./ImageArray.vue?vue&type=template&id=1231d2c2"
import script from "./ImageArray.vue?vue&type=script&lang=js"
export * from "./ImageArray.vue?vue&type=script&lang=js"

import "./ImageArray.vue?vue&type=style&index=0&id=1231d2c2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__